var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { BaseTemplate } from "./base-template";
import * as Enumerable from "linq";
import { RouterConstants } from "../../../configuration/router.constants";
import { computedFrom } from "aurelia-binding";
import { LookupValueRequest, LookupValueQuery } from "../../../models/lookups/lookup.models";
import { NotificationType } from "../../../services/basics/notification-client.service";
var BaseResults = /** @class */ (function (_super) {
    __extends(BaseResults, _super);
    function BaseResults(router, lotteryClientService, lookupClientService, i18N, hotLotteryClientService, tokenClient, notificationClientService, dialogClientService) {
        var _this = _super.call(this, router, i18N, lotteryClientService, dialogClientService, tokenClient) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.lookupClientService = lookupClientService;
        _this.hotLotteryClientService = hotLotteryClientService;
        _this.tokenClient = tokenClient;
        _this.notificationClientService = notificationClientService;
        _this.resultLotteries = [];
        _this.lotteryComboBoxItems = [];
        _this.lotteryDatesComboBoxItems = [];
        _this.lotteryResults = [];
        _this.hotLotteries = [];
        _this.loadingLatestResults = true;
        _this.defaultUserCurrencySymbol = tokenClient.getUserCurrency().symbol;
        return _this;
    }
    BaseResults.prototype.openDraw = function (draw, element) {
        if (element === void 0) { element = null; }
        draw.isOpen = !draw.isOpen;
        if (element) {
            if (draw.isOpen) {
                $(element).slideDown();
            }
            else {
                $(element).slideUp();
            }
        }
    };
    Object.defineProperty(BaseResults.prototype, "selectedLotteryId", {
        get: function () {
            return this._selectedLotteryId ? this._selectedLotteryId : this.lotteryId;
        },
        set: function (x) {
            if (this._selectedLotteryId == x)
                return;
            this._selectedLotteryId = x;
            if (!x)
                this.lotteryId = null;
            this.loadLotteryDates();
            this.getLatestResults();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseResults.prototype, "selectedLotteryDate", {
        get: function () {
            return this._selectedLotteryDate;
        },
        set: function (x) {
            var value = x;
            if (x == this.i18n.tr("most-recent-label"))
                value = null;
            if (this._selectedLotteryDate == value)
                return;
            this._selectedLotteryDate = value;
            this.getLatestResults();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseResults.prototype, "lotteryIdsForLotteryDrawDates", {
        get: function () {
            return this._selectedLotteryId ? this._selectedLotteryId.toString() : Enumerable.from(this.lotteryComboBoxItems).select(function (x) { return x.lotteryId; }).where(function (x) { return x != null; }).toJoinedString("|");
        },
        enumerable: false,
        configurable: true
    });
    BaseResults.prototype.activate = function (params) {
        var _this = this;
        var promise = _super.prototype.activate.call(this, params);
        if (params && params.lotteryId)
            this.lotteryId = params.lotteryId;
        this.lotteryClientService.getResultsBrandLotteries({}).then(function (x) {
            _this.filterResults(x).then(function (a) {
                _this.resultLotteries = a;
                _this.lotteryComboBoxItems = [{ lotteryName: _this.i18n.tr("all-lotteries-label"), lotteryId: null }].concat(a);
                _this.loadLotteryDates();
            });
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
        this.hotLotteryClientService.getHotLotteries().then(function (x) {
            _this.hotLotteries = x;
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
        return promise;
    };
    BaseResults.prototype.filterResults = function (x) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, x];
            });
        });
    };
    BaseResults.prototype.attached = function () {
        _super.prototype.attached.call(this);
        this.getLatestResults();
    };
    BaseResults.prototype.loadLotteryDates = function () {
        var _this = this;
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.lotteryDrawDates;
        request.parameters = this.lotteryIdsForLotteryDrawDates;
        this.lookupClientService.getLookup(request).then(function (x) {
            _this.lotteryDatesComboBoxItems = [{ name: _this.i18n.tr("most-recent-label"), id: null }].concat(x.values);
        });
    };
    BaseResults.prototype.getLatestResults = function () {
        var _this = this;
        this.lotteryClientService.getResultsLatestResults({
            lotteryId: this.selectedLotteryId,
            date: this.selectedLotteryDate,
        }).then(function (x) {
            _this.filterResults(x).then(function (a) {
                _this.lotteryResults = a;
                _this.loadingLatestResults = false;
                _this.resultsLoaded();
            });
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
    };
    BaseResults.prototype.resultsLoaded = function () { };
    BaseResults.prototype.getLotteryById = function (lotteryId) {
        return Enumerable.from(this.resultLotteries).where(function (x) { return x.lotteryId == lotteryId; }).firstOrDefault();
    };
    BaseResults.prototype.getLotterySchedule = function (lotteryId) {
        var lottery = this.getLotteryById(lotteryId);
        var str = [];
        if (lottery.sunday)
            str.push(this.i18n.tr("sunday-text"));
        if (lottery.monday)
            str.push(this.i18n.tr("monday-text"));
        if (lottery.tuesday)
            str.push(this.i18n.tr("tuesday-text"));
        if (lottery.wednesday)
            str.push(this.i18n.tr("wednesday-text"));
        if (lottery.thursday)
            str.push(this.i18n.tr("thursday-text"));
        if (lottery.friday)
            str.push(this.i18n.tr("friday-text"));
        if (lottery.saturday)
            str.push(this.i18n.tr("saturday-text"));
        return str.join(", ");
    };
    BaseResults.prototype.getLotteryKeyById = function (lotteryId) {
        var lottery = Enumerable.from(this.lotteries).where(function (x) { return x.lotteryId == lotteryId; }).firstOrDefault();
        if (lottery)
            return this.getLotteryKey(lottery.lotteryName);
        return null;
    };
    BaseResults.prototype.navigateToLotteryById = function (lotteryId) {
        var lottery = this.getLotteryById(lotteryId);
        var key = this.getLotteryKey(lottery.lotteryName);
        this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
            lotteryId: lottery.lotteryId,
            key: key,
            brandLotteryId: lottery.brandLotteryId
        });
    };
    BaseResults.prototype.getTopBannerLottery = function (lotteryName) {
        lotteryName = this.i18n.tr(lotteryName);
        var lottery = this.getLotteryByKey(this.lotteries, lotteryName);
        return lottery;
    };
    BaseResults.prototype.navigateToLottery = function (lottery) {
        var key = this.getLotteryKey(lottery.lotteryName);
        this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
            lotteryId: lottery.lotteryId,
            key: key,
            brandLotteryId: lottery.brandLotteryId
        });
    };
    BaseResults.prototype.getTiers = function (result) {
        var e_1, _a;
        var list = [];
        var lottery = Enumerable.from(this.resultLotteries).firstOrDefault(function (x) { return x.lotteryId == result.lotteryId; });
        if (lottery && result) {
            var tiers = Enumerable.from(lottery.lotteryPriceTiers).orderBy(function (x) { return x.sequenceNumber; }).toArray();
            try {
                for (var tiers_1 = __values(tiers), tiers_1_1 = tiers_1.next(); !tiers_1_1.done; tiers_1_1 = tiers_1.next()) {
                    var tier = tiers_1_1.value;
                    var item = Enumerable.from(result.tiers).firstOrDefault(function (x) { return x.internalName == tier.internalName; });
                    list.push(item ? item : {
                        alternateText: this.i18n.tr("no-winner"),
                        internalName: tier.internalName,
                        name: tier.name,
                        currencyId: null
                    });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (tiers_1_1 && !tiers_1_1.done && (_a = tiers_1.return)) _a.call(tiers_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return list;
    };
    __decorate([
        computedFrom("_selectedLotteryId"),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], BaseResults.prototype, "selectedLotteryId", null);
    __decorate([
        computedFrom("_selectedLotteryDate"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], BaseResults.prototype, "selectedLotteryDate", null);
    __decorate([
        computedFrom("_selectedLotteryId"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], BaseResults.prototype, "lotteryIdsForLotteryDrawDates", null);
    return BaseResults;
}(BaseTemplate));
export { BaseResults };
